import React from 'react';

const StarRating = ({ value = 4, max = 5 }: { value?: number; max?: number }) => {
  return (
    <div className="flex space-x-0.5">
      {Array.from({ length: max }, (_, index) => (
        <svg
          key={index}
          className={`w-[10px] lg:w-[12px] h-[10px] lg:h-[12px] ${index < value ? 'text-yellow-400' : 'text-gray-300'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.193 3.674a1 1 0 00.95.69h3.862c.969 0 1.371 1.24.588 1.81l-3.124 2.27a1 1 0 00-.364 1.118l1.193 3.674c.3.921-.755 1.688-1.54 1.118l-3.124-2.27a1 1 0 00-1.175 0l-3.124 2.27c-.784.57-1.838-.197-1.539-1.118l1.193-3.674a1 1 0 00-.364-1.118L2.32 9.101c-.783-.57-.38-1.81.588-1.81h3.862a1 1 0 00.95-.69l1.193-3.674z" />
        </svg>
      ))}
    </div>
  );
};

export default StarRating;
